const SearchSystem = {
  namespaced: true,

  state: {
    isAllowedUseSlash: true,
    isFieldFocusedOnOpen: false,
  },

  mutations: {
    //Разрешить/ Запретить открывать попап поиска через слэш
    toChangeAllowedSlashStatus(state, status){ state.isAllowedUseSlash = status; },
    //Сфокусироваться ли на поле при открытии виджета поиска
    toChangeFocusOnOpenStatus(state, status){ state.isFieldFocusedOnOpen = status; }
  },

  getters:{
  
  }
}

export default SearchSystem;